import { CommonModule, NgOptimizedImage } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { UnifiedErrorIconComponent } from './form/error-icon/error-icon.component';
import { UnifiedRegistrationFormComponent } from './form/form.component';
import { UnifiedRegistrationSuccessComponent } from './success/success.component';
import { UnifiedRegistrationApiService } from './unified-registration.api.service';
import { UnifiedEmailVerificationExpiredComponent } from './expired/expired.component';
import { UnifiedEmailVerificationAlreadyVerifiedComponent } from './already-verified/already-verified.component';
import { UnifiedRegistrationErrorComponent } from './error/error.component';
import { UnifiedSetPasswordComponent } from './set-password/set-password.component';
import { UnifiedRegistrationLayoutComponent } from './layout/layout.component';
import { CustomRegistrationLandingComponent } from './custom-registration-landing/custom-registration-landing.component';
import { UnifiedAlreadySignedInComponent } from './already-signed-in/already-signed-in.component';

@NgModule({
  declarations: [
    UnifiedAlreadySignedInComponent,
    UnifiedErrorIconComponent,
    UnifiedRegistrationFormComponent,
    UnifiedRegistrationSuccessComponent,
    UnifiedEmailVerificationExpiredComponent,
    UnifiedEmailVerificationAlreadyVerifiedComponent,
    UnifiedRegistrationErrorComponent,
    UnifiedSetPasswordComponent,
    UnifiedRegistrationLayoutComponent,
    CustomRegistrationLandingComponent,
  ],
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UIRouterUpgradeModule.forRoot(),
    NgOptimizedImage],
  providers: [UnifiedRegistrationApiService, provideHttpClient(withInterceptorsFromDi())],
})
export class UnifiedRegistrationModule { }
